export default "__VITE_ASSET__D3ah5R92__"